import { render, staticRenderFns } from "./expressInfo_modal.vue?vue&type=template&id=4c7c40b8&scoped=true&"
import script from "./expressInfo_modal.vue?vue&type=script&lang=js&"
export * from "./expressInfo_modal.vue?vue&type=script&lang=js&"
import style0 from "./expressInfo_modal.vue?vue&type=style&index=0&id=4c7c40b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c40b8",
  null
  
)

export default component.exports